import {useState, useRef, useCallback, RefObject} from 'react';

type MenuAnchor = undefined | HTMLElement;
type MenuActions = {
  open: (anchor: HTMLElement) => any;
  close: () => any;
  anchor: MenuAnchor;
  firstMenuItemRef: RefObject<HTMLLIElement>;
  focusFirstMenuItem: () => void;
};
type MenuStateProviderProps = {
  children: (actions: MenuActions) => JSX.Element;
};
const MenuStateProvider = (props: MenuStateProviderProps) => {
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(undefined);
  const firstMenuItemRef = useRef<HTMLLIElement>(null);

  const focusFirstMenuItem = useCallback(() => {
    firstMenuItemRef.current?.focus()
  }, [])

  return props.children({
    anchor: menuAnchor,
    close: () => setMenuAnchor(undefined),
    open: setMenuAnchor,
    firstMenuItemRef: firstMenuItemRef,
    focusFirstMenuItem: focusFirstMenuItem,
  });
};

export default MenuStateProvider;
